<template>
  <div sp-privacy-policy-text="direct-text" sp-lang-code="en"></div>

</template>

<script>
export default {
  name: "PrivPolicy",
  data() {
    //<iframe id="ifrmPrivacyPolicyDirectText" title="Privacy policy" src="https://app.secureprivacy.ai/privacyPolicy/privacy-policy.html?apikey=53ad3083da00468ca9b72b2bae37e2c024c92f8074434c2881664de2f7833a1fcaaf34172d284463bd41ee3fbbb44243&amp;domain=63ec9d98c72561e10655e18c&amp;lang=en&amp;compliance=GDPR,CCPA,LGPD&amp;type=text&amp;height=700px" style="width: 100%; height: 700px; background-color: rgb(255, 255, 255);"></iframe>
    return {};
  },
};
</script>

<style scoped lang="scss">
</style>
